/* ===============================
  重設密碼的 controller
  Author: Gray
  最後更新日期：2016 / 09 / 09
================================*/
window.InifECMobileApp.controller('ResetPasswordController', ['$scope', '$rootScope', '$stateParams',
    function($scope, $rootScope, $stateParams) {

        var init = function() {
            $rootScope.$broadcast('OPEN_RESET_PW_MODAL', {
                email: $scope.email,
                token: $scope.token
            });
        }

        /*==========================
          Members
        ==========================*/
        $scope.email = $stateParams.email;
        $scope.token = $stateParams.token;

        /*==========================
          init
        ==========================*/
        init();
    }
])
